import { useRouter } from "next/router";

export const Tab = ({ active }: { active: string }) => {
  const router = useRouter();
  return (
    <nav className="camp-tab">
      <div
        className={`common left ${active === "left" && "left-selected"}`}
        onClick={() => router.push("/fullstack")}
      >
        远程Web全栈训练营
      </div>
      <div
        className={`common right ${active === "right" && "right-selected"}`}
        onClick={() => router.push("/english")}
      >
        远程工作求职训练营
      </div>
    </nav>
  );
};
